/*Modal Login And Register*/
export const handelOpenModalLoginAndRegister = () => ({
    type: 'OPEN_MODAL_LOGIN_AND_REGISTER'
});
export const handelCloseModalLoginAndRegister = () => ({
    type: 'CLOSE_MODAL_LOGIN_AND_REGISTER'
});
export const handelChangeTabSelectModalLoginAndRegister = (tabSelect) => ({
    type: 'CHANGE_TAB_SELECT_MODAL_LOGIN_AND_REGISTER',tabSelect
});
export const handelChangeInputModalLoginAndRegister = (name,value) => ({
    type: 'CHANGE_INPUT_MODAL_LOGIN_AND_REGISTER',name,value
});
export const handelChangeInputsBaseModalLoginAndRegister = (phoneNumber,code) => ({
    type: 'CHANGE_INPUTS_BASE_MODAL_LOGIN_AND_REGISTER',phoneNumber,code
});
export const handelChangeDisabledBtnModalLoginAndRegister = (disabledBtn) => ({
    type: 'CHANGE_DISABLED_BTN_LOGIN_AND_REGISTER',disabledBtn
});
export const handelChangeTimerTimeModalLoginAndRegister = (timer_time) => ({
    type: 'CHANGE_TIMER_TIME_LOGIN_AND_REGISTER',timer_time
});
export const handelRestartFormLoginAndRegister = () => ({
    type: 'CHANGE_RESTART_FORM_LOGIN_AND_REGISTER'
});
export const ChangeLoaderGetPassLoginAndRegister = (loaderGetPssLogin) => ({
    type: 'CHANGE_LOADER_GET_PASS_LOGIN_AND_REGISTER',loaderGetPssLogin
});
export const ChangeLoaderFinalBtnLoginAndRegister = (loaderFinalLogin) => ({
    type: 'CHANGE_LOADER_FINAL_BTN_LOGIN_AND_REGISTER',loaderFinalLogin
});